import { render, staticRenderFns } from "./modalAsignarTablero.vue?vue&type=template&id=23422fd6&scoped=true&"
import script from "./modalAsignarTablero.vue?vue&type=script&lang=js&"
export * from "./modalAsignarTablero.vue?vue&type=script&lang=js&"
import style0 from "./modalAsignarTablero.vue?vue&type=style&index=0&id=23422fd6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23422fd6",
  null
  
)

export default component.exports